// Process-wide TanStack Query client config.
//
// Defaults:
//
// - ``staleTime: 30_000`` (30s). Queries that haven't been touched
//   in the last 30 seconds are eligible for refetch on the next
//   trigger. Default would be 0 (immediately stale) which over-
//   refetches, especially in tab-focus scenarios where many
//   queries fire at once.
// - ``refetchOnWindowFocus: true``. Refresh data when the user tabs
//   back into the Sheafworks tab. This isn't real-time (that's
//   server-sent events, deferred); it covers the much more common
//   "I came back and things were stale" feeling.
// - ``retry: 1``. One automatic retry on failed queries before
//   surfacing the error to the user.
//
// The instance is exported so tests can assert the defaults
// directly without parsing rendered output.

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
  },
});
